import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { shippingAddressMsg, t } from '../../common/i18n/index.js';
import { formatSum } from '../../common/utils/priceUtils.js';
import { DeliveryType, OnlineOrder } from '../../generated/api/models.js';
import { DeliveryAddressType } from '../DeliveryAddress/DeliveryAddress.js';
import type { DeviceCheckoutDeliveryDetailsType } from '../DeviceCheckoutDeliveryDetails/DeviceCheckoutDeliveryDetailsUtils.js';

interface DeviceCheckoutThankYouDeliveryDetailsProps {
  deliveryDetails: DeviceCheckoutDeliveryDetailsType;
  companyName: string;
  skipDelivery: boolean;
  shipmentType?: OnlineOrder.ShipmentTypeEnum;
  shipmentTypeEnabled?: boolean;
}

const isDeliveryToAddress = (deliveryMethodType: DeliveryType) =>
  [
    DeliveryType.MATKAHUOLTO_JAKOPAKETTI,
    DeliveryType.POSTI_EXPRESS_BUSINESS,
    DeliveryType.POSTI_EXPRESS_MORNING,
  ].includes(deliveryMethodType);

export const DeviceCheckoutThankYouDeliveryDetails = ({
  deliveryDetails,
  companyName,
  skipDelivery,
  shipmentType,
  shipmentTypeEnabled = true, // Default to true for non-punchout flows
}: DeviceCheckoutThankYouDeliveryDetailsProps) => {
  const isDelivery = isDeliveryToAddress(deliveryDetails.deliveryMethodType);
  const shouldShowShipmentType = shipmentTypeEnabled && shipmentType === OnlineOrder.ShipmentTypeEnum.TOTAL_DELIVERY;

  return skipDelivery ? (
    <></>
  ) : (
    <div className="of-device-checkout-thankyou__delivery-details">
      <CL.Grid>
        <CL.GridRow>
          <CL.GridCol colsXS={1} colsS={1} className="of-device-checkout__images">
            <CL.Icon icon={isDelivery ? 'delivery' : 'location'} size="xl" type="light" />
          </CL.GridCol>
          <CL.GridCol colsXS={3} colsS={5}>
            <CL.Grid>
              <CL.GridRow>
                <CL.GridCol colsXS={4} colsS={5} className={dsClass.MARGIN_BOTTOM_4}>
                  <h3 className={dsClass.MARGIN_VERTICAL_2}>{deliveryDetails.deliveryMethodDescription}</h3>
                  {isDelivery
                    ? deliveryDetails.address && (
                        <div className="of-device-checkout-thankyou__delivery-details--address">
                          {t.IHO6(shippingAddressMsg)}:
                          <div>
                            {deliveryDetails.addressType === DeliveryAddressType.HOME_ADDRESS ? '' : companyName}
                          </div>
                          <div>{deliveryDetails.address.line1}</div>
                          <div>{deliveryDetails.address.line2}</div>
                          <div>
                            {deliveryDetails.address.postalCode}, {deliveryDetails.address.postOffice}
                          </div>
                        </div>
                      )
                    : deliveryDetails.pickupPoint?.address && (
                        <div className="of-device-checkout-thankyou__delivery-details--address">
                          {t.IHO6(shippingAddressMsg)}:<div>{deliveryDetails.pickupPoint.name}</div>
                          <div>{deliveryDetails.pickupPoint.address}</div>
                        </div>
                      )}
                  {shouldShowShipmentType && (
                    <div>
                      <h4 className={dsClass.H4}>{t.BSE3('Delivery')}:</h4>
                      <div>{t.LMKE('When all products are available')}</div>
                    </div>
                  )}
                </CL.GridCol>
                <CL.GridCol colsXS={4} colsS={1} className="of-device-checkout-thankyou__delivery-details--price">
                  <h4 className={dsClass.MARGIN_VERTICAL_2}>{formatSum(deliveryDetails.deliveryPrice)}</h4>
                </CL.GridCol>
              </CL.GridRow>
            </CL.Grid>
          </CL.GridCol>
        </CL.GridRow>
      </CL.Grid>
    </div>
  );
};
